import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * MemberNameLink - Reusable clickable name that navigates to member profile.
 *
 * Props:
 *   memberId  - UUID of the family member
 *   name      - Display name string (used if no children provided)
 *   style     - Optional inline styles
 *   className - Optional CSS class
 *   children  - Optional ReactNode to render instead of name
 */
function MemberNameLink({ memberId, name, style, className, children }) {
  const navigate = useNavigate();

  // If no memberId, render plain text
  if (!memberId) {
    return <span style={style} className={className}>{children || name}</span>;
  }

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    navigate(`/family-hub/member/${memberId}`);
  };

  return (
    <span
      onClick={handleClick}
      role="link"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter') handleClick(e); }}
      style={{
        cursor: 'pointer',
        textDecoration: 'none',
        ...style,
      }}
      className={className}
      onMouseEnter={(e) => { e.currentTarget.style.textDecoration = 'underline'; }}
      onMouseLeave={(e) => { e.currentTarget.style.textDecoration = 'none'; }}
    >
      {children || name}
    </span>
  );
}

export default MemberNameLink;
